export default function CartContent() {
  return <section data-section-id="190455" id="cart-content" className="bg-background text-foreground py-12 md:py-24 w-full min-h-[60vh]">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="mb-10 border-b border-border/50 pb-6">
          <h1 className="text-3xl md:text-5xl font-bold text-primary mb-3 tracking-wide font-serif" style={{
          fontFamily: '"Fredoka One", cursive'
        }}>
            購物車 / SHOPPING CART
          </h1>
          <p className="text-foreground/70 text-base md:text-lg max-w-2xl font-sans" style={{
          fontFamily: '"Lato", sans-serif'
        }}>
            確認您的精選地板與材料，為您的空間打造完美基底。 / Review your selected flooring and materials.
          </p>
        </div>

        <div className="w-full bg-card rounded-lg shadow-sm border border-border/40 p-4 md:p-8">
        </div>
      </div>
    </section>;
}